import { Text as UnstyledText } from 'features/common/components/Text';
import { hideScrollbar } from 'styles';
import styled from 'styled-components';

export const Column = styled.div`
	width: 100%;
	display: flex;
	overflow-y: scroll;
	max-width: 620px;
	align-items: center;
	flex-direction: column;

	${hideScrollbar}
`;

export const Subtitle = styled(UnstyledText)`
	font-size: 18px;
`;

export const FieldSet = styled.div`
	gap: 16px;
	width: 100%;
	display: flex;
	overflow: scroll;
	max-width: 620px;
	padding-bottom: 24px;
	flex-direction: column;
	margin-top: 100px;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		margin-top: 0;
	}

	::-webkit-scrollbar {
		display: none;
	}
`;

export const ScreenTitle = styled.div`
	top: 0;
	left: 0;
	right: 0;
	z-index: 4;
	height: 100px;
	display: flex;
	position: fixed;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	background: ${({ theme }) => theme.colors.blackGrey};

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		top: 125px;
		background: transparent;
		position: unset;
	}
`;

export const TotalPriceContainer = styled.div`
	width: 100%;
	display: flex;
	padding: 0 15px;
	border-radius: 4px;
	flex-direction: column;
	box-sizing: border-box;
	border: ${({ theme }) => `1px solid ${theme.colors.white}`};
`;

export const TotalPrice = styled(UnstyledText)`
	opacity: 0.7;
	font-size: 20px;
	font-weight: 400;
`;

export const TotalPriceInfo = styled(UnstyledText)`
	font-size: 13px;
	font-weight: 400;
	text-transform: none;
`;

export const ButtonGroup = styled.div`
	display: flex;
	gap: 16px;
	width: 100%;
`;

export const CancelButton = styled.button`
	flex: 1;
	padding: 12px;
	border: 1px solid #e86339;
	border-radius: 4px;
	color: #e86339;
	background: transparent;
	cursor: pointer;
`;

export const CreateButton = styled.button`
	flex: 1;
	padding: 12px;
	border: none;
	border-radius: 4px;
	color: white;
	background: #e86339;
	cursor: pointer;

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`;
